
// --- USER CONFIGURATION ---

// 1. ADMINS
// These users see the Admin Dashboard.
// Security Note: It is normal for business emails to be public. 
// Security relies on your password/auth provider, not hiding the email here.
export const ADMIN_EMAILS = [
    'forgivepath@gmail.com',    // Main Business Email
    'YASEnterpriseLLC@gmail.com', // Production Admin
];

// 2. TESTERS
// These users automatically get "Test Mode" enabled (bypassing payment/docs).
// TIP: Use Gmail aliases (e.g. yourname+test@gmail.com) to test as a "new user"
// while still receiving emails to your main inbox.
export const TESTER_EMAILS = [
    'olgashinkar@gmail.com',
    'twinsautotransport@gmail.com',
    'forgivepath+test@gmail.com',  // Alias: Routes to forgivepath@gmail.com but acts as new user
    'yanashinkar+test@gmail.com',  // Alias: Routes to yanashinkar@gmail.com but acts as new user
    'yanashinkar@gmail.com',       // Personal email (Tester access only)
];
